import React from "react"

import { QueryClient, QueryClientProvider } from "react-query"
import { ReactQueryDevtools } from "react-query/devtools"

const defaultClient = new QueryClient({
	defaultOptions: {
		queries: {
			refetchOnWindowFocus: false,
			staleTime: 1000 * 60, // 1 min stale time
		},
	},
})

interface ReactQueryClientProviderProps {
	children: React.ReactNode
	client?: QueryClient
}

export const ReactQueryClientProvider: React.FC<ReactQueryClientProviderProps> = ({
	children,
	client = defaultClient,
}) => {
	return (
		<QueryClientProvider client={client}>
			<ReactQueryDevtools initialIsOpen={false} />
			{children}
		</QueryClientProvider>
	)
}
